module.exports = __webpack_public_path__ + "7ed1e723ada414928b6f5da2927823c8.png";